import type { IconProps } from '../types/IconProps.ts';
export const GlobeCheck: IconProps = {
    name: 'GlobeCheck',
    children: [
        `<path d="M11 2.05A10 10 0 1 0 22 12M2 12h20" />`,
        `<path d="M11 2.31C9.27 3.43 8 7.34 8 12c0 5.52 1.8 10 4 10s4-4.48 4-10M13 6l2.62 1.75c.21.14.5.1.67-.1L20 3" />`,
    ]
};